import {PayloadAction} from "@reduxjs/toolkit";
import {Reducer} from "redux";
import {INIT} from "../rootActions";
import {MODULE_CONFIGS_SET} from "./moduleConfigsActions";
import {ModuleConfigsState} from "./types";

const initialState: ModuleConfigsState = {
  _moduleConfigFiles: [],
  modules: [],
  configs: {},
  placeholders: {},
  hubRoutes: [],
  nodeRoutes: [],
  hubPermissions: [],
  nodePermissions: [],
  tableActionFactories: {}
};

const moduleConfigsReducer: Reducer<ModuleConfigsState, PayloadAction<any>> = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...state,
        _moduleConfigFiles: action.payload.moduleConfigFiles
      };
    }
    case MODULE_CONFIGS_SET: {
      return {
        ...state,
        ...action.payload.moduleConfigs
      };
    }
    default:
      return state;
  }
};

export default moduleConfigsReducer;
